import React, { MouseEventHandler, useState } from 'react';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Button from 'b2b-ui-components-lib/lib/components/button';

import { handleError } from 'common/utils/app.utils';
import { EDIT_CART_ACTION, getBulkEditRequest } from '../configure-plan-pricing-constant';
import { doBulkEditAction } from '../configure-plan-pricing.service';
import { preOrderPeriodOptions, isNLD_OR_LL } from 'common/constants/app.constants';
import './contract-period.scss';
import { getPreOrderPeriod, getTotalLinks } from './formControl.service';

type Props = {
  hidePopup: MouseEventHandler;
  records: Array<any>;
  reFetchRecords: Function;
};

export const PreOrderPeriod = ({ hidePopup, records, reFetchRecords }: Props) => {
  const [preOrderPeriod, setPreOrderPeriod] = useState<{ displayName: string; key: string }>(getPreOrderPeriod(records));
  const [loader, setLoader] = useState<boolean>(false);

  const savePreOrderPeriodHandler = () => {
    setLoader(true);
    const requestParam = getBulkEditRequest(EDIT_CART_ACTION.EDIT_PRE_ORDER_DURATION, records, preOrderPeriod?.key);
    doBulkEditAction(requestParam).then(
      (response: any) => {
        setLoader(false);
        reFetchRecords?.();
        hidePopup?.(false as any);
      },
      (err: any) => {
        setLoader(false);
        handleError(err);
      }
    );
  };

  const preOrderPeriodHandler = (value: { displayName: string; key: string }) => {
    setPreOrderPeriod(value);
  };

  const getMessage = () => {
    if (isNLD_OR_LL()) {
      return (
        <p className="contract-message">
          <span>{getTotalLinks(records)} selected links</span> will be updated as per the pre order period selected below. Are you sure you want to proceed?
        </p>
      );
    }

    return (
      <p className="contract-message">
        <span>{getTotalLinks(records)} selected links</span> will be updated as per the pre order period selected below. Please note that the pre order period for secondary link
        will remain same as the primary link.
      </p>
    );
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder contractPeriod">
        <h2 className="cancel-head">Change Pre Order Period</h2>
        {getMessage()}
        <div className="row">
          <div className="flg-lg-5 flg-sm-12">
            <Select
              placeholder="Pre Order Period"
              value={preOrderPeriod}
              onChange={preOrderPeriodHandler}
              options={preOrderPeriodOptions}
              required
              touched
              label="Pre Order Period"
            />
          </div>
        </div>

        <div className="characters">&nbsp;</div>
        <div className="buttonSection">
          <Button type="button" buttonClass="btn" variant="outlinebtn" onClick={hidePopup}>
            Cancel
          </Button>
          <Button type="button" disabled={loader} onClick={savePreOrderPeriodHandler}>
            Change
            {loader && <span className="loading_icon"></span>}
          </Button>
        </div>
      </div>
    </div>
  );
};
